import React, { Component } from "react";
import parseXML from "xml-parse-from-string";

import SVG from 'svg.js';
import 'svg.draggable.js';
import 'svg.connectable.js';

import Files from 'react-files';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  setTranslateX,
  setTranslateY,
  setZoom,
  setTempAddFloorplan
} from '../../reducers/floorplans';


import svgPanZoom from 'svg-pan-zoom';

import './Floorplan.css';

class Floorplan extends Component {

  state = {
    file: null,
    floorplanPaths: []
  }

  componentWillReceiveProps = (prevProp, nextProp) => {
  }

  componentDidMount = () => {
      
  }

  handleFileChange = (file) => {
    this.props.setTempAddFloorplan(file[0]);
    this.setState({file: file[0]}, () => { this.generatePaths();} );
  }

  generatePaths = () => {
    const reader = new FileReader();
    this.draw = SVG('floorplan-add');
    this.gridGroup = this.draw.group();
    const pathGroup = this.draw.group();

    this.draw.circle(10).fill('rgba(0,0,0,0)').move(10,10);

    const pathArray = [];
    reader.readAsText(this.state.file);
    reader.onloadend = () => {

      const svgPaths = parseXML(reader.result).getElementsByTagName("path");

      Array.from(svgPaths).forEach((path) => {
        const pathItem = {id: path.id, d: path.getAttribute("d") };
        const pathItemSVG = pathGroup.path(path.getAttribute("d")).attr({class: 'path-item', 'stroke-width': '0.5', stroke: '#999'}).fill('rgba(255,255,255,0)');
        pathItemSVG.on('click', (event) => {
        });
        pathItemSVG.on('mouseout', (event) => {
          // this.props.showHidePopover(false);
        });
        pathItem.pathItemSVG = pathItemSVG;
        pathArray.push(pathItem);
      });

    };

    this.setState({
      floorplanPaths: pathArray
    }, () => { this.setChildPanZoom(); } );


  }

  componentDidUpdate = () => {

  }

  setChildPanZoom = () => {
    try {

      const onPan = (event) => {
        this.props.setZoom(this.panZoomInstance.getZoom());
        this.props.setTranslateX(event.x);
        this.props.setTranslateY(event.y);
      };

      const onZoom = (event) => {
        this.props.setZoom(event);
        this.props.setTranslateX(this.panZoomInstance.getPan().x);
        this.props.setTranslateY(this.panZoomInstance.getPan().y);
      }

      this.panZoomInstance = svgPanZoom('.SVGContainer', {
        zoomEnabled: true,
        controlIconsEnabled: false,
        fit: true,
        center: true,
        minZoom: 0.01,
        maxZoom: 0.5,
        onPan: onPan,
        onZoom: onZoom
      });

    } catch(e) {

    }

    this.panZoomInstance.zoom(this.props.zoom);
    // this.panZoomInstance.pan({x: this.props.translateX, y: this.props.translateY});
    // Set Center
    if(this.props.translateX === 0 && this.props.translateY === 0) {
      this.panZoomInstance.pan({x: this.panZoomInstance.getSizes().width * -1, y: this.panZoomInstance.getSizes().height * -1});
    } else {
      this.panZoomInstance.pan({x: this.props.translateX, y: this.props.translateY});
    }

    this.gridLines = this.gridGroup.rect(10000, 10000).cx(0).cy(0);
    this.pattern = this.draw.pattern(20, 20, (add) => {
      add.line(0, 0, 0, 20).stroke({ width: 1 }).attr({'stroke': 'rgba(0,0,0,.1)'})
      add.line(0, 0, 20, 0).stroke({ width: 1 }).attr({'stroke': 'rgba(0,0,0,.1)'})
    });
    this.setGridLines();
  }

  setGridLines = () => {

    if(this.props.gridLines){
      this.gridLines.fill(this.pattern); 
    } else {
      this.gridLines.fill('rgba(255,255,255,0)'); 
    }

    this.gridLines.rotate(this.props.rotation);
  }


  componentWillUnmount = () => {
  }

  render() {
    
    return (
      <div style={{height: '100%', display: 'flex', flexGrow: 1, flexDirection: 'column', padding: '0px'}}>
        {this.state.file ? 
          '' :
          <Files name="svg" accepts={['.svg']} clickable className="field-drop inputClass" onChange={this.handleFileChange} style={{display: 'block', position: 'absolute', top: '0px', height: '100%', width: '100%'}} dropActiveClassName="dropping">
            <div className="centered"><a className="btn btn-primary">Drop floorplan file (.svg) here or click to add</a></div>
          </Files>
        }
        <svg width="100%" id="floorplan-add" className={`SVGContainer ${this.props.toolbar}`} style={{height: '100%', flexGrow: 1}}></svg>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translateX: state.floorplans.translateX,
  translateY: state.floorplans.translateY,
  zoom: state.floorplans.zoom,
  gridLines: state.floorplans.gridLines,
  rotation: state.floorplans.rotation
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setTranslateX,
      setTranslateY,
      setZoom,
      setTempAddFloorplan
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Floorplan);



// WEBPACK FOOTER //
// ./src/components/Floorplan/FloorplanAdd.js